import styled from 'styled-components'
import iconAberto from '@assets/images/logo-aberto-white.svg'

const HeaderPage = styled.header`
  background: var(--dark-blue);
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  margin: 0 -20px;
`

const Logo = styled.span`
  background: url(${iconAberto}) no-repeat;
  width: 136px;
  height: 30px;
  overflow: hidden;
  text-indent: -150px;
`

export { HeaderPage, Logo }
